import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getSetupDetails } from "../store/AsyncMethods/SetupMethod";

const AppBranding = ({ children }) => {
  const dispatch = useDispatch();
  const { setupDetails } = useSelector((state) => state.SetupReducer);

  useEffect(() => {
    dispatch(getSetupDetails());
  }, [dispatch]);

  useEffect(() => {
    if (setupDetails?.name) {
      document.title = setupDetails.name;
    }

    if (setupDetails?.logo) {
      const favicon =
        document.querySelector("link[rel='icon']") ||
        document.createElement("link");
      favicon.rel = "icon";
      favicon.type = "image/png";
      favicon.href = `${setupDetails.logoPath + setupDetails.logo}`;
      document.head.appendChild(favicon);
    }

    if (setupDetails?.colorPrimary && setupDetails?.colorSecondary) {
      const primaryColor = `#${setupDetails.colorPrimary}`;
      const secondaryColor = `#${setupDetails.colorSecondary}`;

      const primaryHSL = hexToHSL(primaryColor);
      const primaryNormal = adjustLightness(primaryHSL, 40);
      const primaryLight = adjustLightness(primaryHSL, 85);

      document.documentElement.style.setProperty("--primary", primaryColor);
      document.documentElement.style.setProperty(
        "--primary-normal",
        primaryNormal
      );
      document.documentElement.style.setProperty(
        "--primary-light",
        primaryLight
      );
      document.documentElement.style.setProperty("--secondary", secondaryColor);
    }
    if (setupDetails?.fontStyle) {
      document.documentElement.style.setProperty(
        "--fontStyle",
        setupDetails.fontStyle
      );
    }
  }, [setupDetails]);

  return <>{children}</>;
};

// Helper function to convert Hex to HSL
const hexToHSL = (hex) => {
  let r = parseInt(hex.slice(1, 3), 16);
  let g = parseInt(hex.slice(3, 5), 16);
  let b = parseInt(hex.slice(5, 7), 16);

  r /= 255;
  g /= 255;
  b /= 255;

  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);

  let h = 0;
  let s = 0;
  let l = (max + min) / 2;

  if (max !== min) {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);

    switch (max) {
      case r:
        h = (g - b) / d + (g < b ? 6 : 0);
        break;
      case g:
        h = (b - r) / d + 2;
        break;
      case b:
        h = (r - g) / d + 4;
        break;
    }

    h /= 6;
  }

  return [h * 360, s * 100, l * 100];
};

// Helper function to adjust HSL lightness
const adjustLightness = (hsl, lightness) => {
  return `hsl(${hsl[0]}, ${hsl[1]}%, ${lightness}%)`;
};

export default AppBranding;
